module.exports = __webpack_public_path__ + "media/images/login-bg@3x-e38d3bca921dd66c7f5b173fb3720a1f.png";